export default __webpack_public_path__ + "static/media/carimage.72ce418c.jpg";